<template>
    <v-layout>
        <v-flex>
            <v-card flat>
                <v-card-title class="primary headline white--text">
                    Summary
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                </v-card-actions>

        <v-card-text>
            <v-data-table
                    :headers="headers"
                    :items="desserts"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.equipment }}</td>
          <td class="text-xs-left">{{ props.item.overall_health }}</td>
          <td class="text-xs-left"><span @click="$router.push(
          {name: 'fault', query: {
          equipment: props.item.equipment
        }})">{{ props.item.active_issues }}</span></td>
          <td class="text-xs-left"><span @click="$router.push({name: 'maintenancerecord'})">{{ props.item.last_maintenance }}</span></td>
        <td class="text-xs-left">{{ props.item.last_on }}</td>
          <td class="text-xs-left"><span @click="$router.push({name: 'maintenancerecord'})">{{ props.item.unfixed_tickets }}</span></td>
          <td class="text-xs-left"><span @click="$router.push(
          {name: 'anomaly',
          query: {equipment: props.item.equipment}
          })">{{ props.item.anomaly_scores }}</span></td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
        </v-card-text>
    </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
  import {getEquipSummary} from '../helper'

  export default {
    name: 'Summary',
    data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Equipment',
          align: 'left',
          sortable: true,
          value: 'equipment'
        },
        { text: 'Fault Scores', value: 'overall_health' },
        { text: 'Active Issues', value: 'active_issues' },
        { text: 'Last Maintenance', value: 'last_maintenance' },
        { text: 'Last On', value: 'last_on'},
        { text: 'Unfixed Tickets', value: 'unfixed_tickets' },
        { text: 'Anomaly Scores', value: 'anomaly_scores'}
      ],
      desserts: [
        {
          equipment: 'Chiller 1',
          overall_health: 0.1,
          active_issues: 10,
          last_maintenance: '2018-09-30',
          last_on: '2019-01-30',
          unfixed_tickets: 3,
          anomaly_scores: 0.1,
          machine_learning_scores: 0.2
        }
      ],
      editedIndex: -1,
      editedItem: {
      },
      defaultItem: {
        name: '',
        calories: 0,
        fat: 0,
        carbs: 0,
        protein: 0
      }
    }),
    created () {
      this.initialize()
      //this.refresh()

    },
    watch: {

    },
    methods: {
      initialize () {
        this.refresh()
      },
      async refresh() {
        let output = []
        for (let i in this.$store.state.pointsListStore.pointsList.equipment_names){
          let df = getEquipSummary({
            facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
            equipment_name: this.$store.state.pointsListStore.pointsList.equipment_names[i]
          })
          output.push(df)
        }
        for (let j in output) {
          output[j] = await output[j]
        }
        this.desserts = output
      }
    }
  }
</script>

<style scoped>

</style>
